import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-list-menu',
  templateUrl: './list-menu.component.html',
  styleUrls: ['./list-menu.component.css']
})
export class ListMenuComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();
  //public links = [{link: 'Inicio', fragment: 'inicio'}, {link: 'El Proceso', fragment: 'proceso'}, {link: 'Historia', fragment: 'historia'}, {link: 'Comprar', fragment: 'comprar'}, {link: 'Seamos Amigos', fragment: 'amigos'}, {link: 'Paquetes', fragment: 'paquetes'}, {link: 'Contacto', fragment: 'contacto'}]
  public links = [{link: 'Inicio', fragment: 'inicio'}, {link: 'El Proceso', fragment: 'proceso'}, {link: 'Historia', fragment: 'historia'}, {link: 'Comprar', fragment: 'comprar'}, {link: 'Seamos Amigos', fragment: 'amigos'}, {link: 'Contacto', fragment: 'contacto'}]
  public active: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  public onSidenavClose = () => {
    this.sidenavClose.emit();
  }

}
